/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type HideReviewedFilterSchemaTimeUnit = typeof HideReviewedFilterSchemaTimeUnit[keyof typeof HideReviewedFilterSchemaTimeUnit] | null;


export const HideReviewedFilterSchemaTimeUnit = {
  days: 'days',
  weeks: 'weeks',
  months: 'months',
  years: 'years',
} as const;
